/** @format */

import * as actionTypes from "../types";
import { apiError } from "../../utils/GTMDataLayer";
import { logger } from "@goldenbird1/ui-logger-library";
import Router from "next/router";
import { v4 as uuidv4 } from "uuid";

const ACCESS_KEY_CURRENCY = "87ae633e1a755dc2a6daca48416a3a46";
let retryCountIP = 0;

export const setCurrency = (currencies, rates) => {
  return {
    type: actionTypes.GET_CURRENCY_CONVERSION,
    payload: { currencies, rates },
  };
};

export const setCurrencyFormat = (convertToCurrency) => {
  return {
    type: actionTypes.GET_CURRENCY_CONVERSION_FORMAT,
    payload: { convertToCurrency },
  };
};

export const getCurrentFormat = (convertToCurrency) => {
  return (dispatch) => {
    dispatch(setCurrencyFormat(convertToCurrency));
  };
};

export const setUserIPDetails = (ipDetails) => {
  return {
    type: actionTypes.GET_USER_IP_DETAILS,
    payload: {
      ipDetails: ipDetails,
    },
  };
};

export const getCurrencyConversion =
  (base, buyerId, callback = "") =>
  async (dispatch) => {
      let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/home/v1/currencies/conversion-rates?base=USD`;
    let hours = 6;
    let saved = sessionStorage.getItem("currencySaved");
    let currencyDetails = sessionStorage.getItem("currencyDetails");
    let retryCount = 0;

    const getExchangeRateDetails = () => {
      let apiURL = `https://api.exchangeratesapi.io/v1/latest?base=${base}&access_key=${ACCESS_KEY_CURRENCY}`;
      fetch(apiURL, {
        method: "GET",
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            apiError('getExchangeRateDetails',  res.statusText || "Error while saving user deatils.", 'GET', 'currencyConverter');
            throw res;
          }
        })
        .then((res) => {
          let fallbackData = {
            USD: 1.0,
          };
          let currencies;
          if (res["success"] === true) {
            currencies = res["rates"];
          } else {
            currencies = fallbackData;
          }

          sessionStorage.setItem("currencySaved", new Date().getTime());
          let rates = Object.keys(currencies).sort();
          let obj = {};
          obj["rates"] = currencies;
          if (callback) {
            callback(res);
          } else {
            return dispatch(setCurrency(rates, currencies));
          }
          sessionStorage.setItem("currencyDetails", JSON.stringify(obj));
        })
        .catch((err) => {
          logger("error", "Error from getExchangeRateDetails api:" +apiURL+ " : error => " +err.statusText+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
          apiError('getExchangeRateDetails',  err.statusText, 'GET', 'currencyConverter');
          let obj = sessionStorage.getItem("currencyDetails") || {};
          obj = JSON.parse(obj);
          let currencies = obj["rates"] || { USD: 1.0 };
          let rates = Object.keys(currencies).sort();
          return dispatch(setCurrency(rates, currencies));
          if(err.status === 401){
            Router.push('/signin');
          }
        });
    };

    const getCurrencyDetails = () => {
      fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          'trace-id' : uuidv4()
        },
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw res;
          }
        })
        .then((res) => {
          sessionStorage.setItem("currencySaved", new Date().getTime());
          let currencies = res["rates"] || { USD: 1.0 };
          let rates = Object.keys(currencies).sort();
          let obj = {};
          obj["rates"] = currencies;
          if (callback) {
            callback(obj);
          }
          sessionStorage.setItem("currencyDetails", JSON.stringify(obj));
          return dispatch(setCurrency(rates, currencies));
        })
        .catch((err) => {
          logger("error", "Error from getCurrencyDetails api:" +url + " : error => " +err.statusText+ ': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
          if(err.status === 401){
            Router.push('/signin');
          } else {
            if (retryCount < 3) {
              getCurrencyDetails();
            } else {
              apiError('getCurrencyDetails',  err.statusText, 'GET', 'currencyConverter');
              if(callback) {
                callback({ error : true });
              }
              // (process.env.NODE_ENV === 'production') && getExchangeRateDetails();
            }
            retryCount++;
          }
        });
    };

    if (
      saved &&
      currencyDetails &&
      new Date().getTime() - saved > hours * 60 * 60 * 1000
    ) {
      getCurrencyDetails();
    } else {
      if (
        sessionStorage.getItem("currencyDetails") &&
        sessionStorage.getItem("currencySaved")
      ) {
        let obj = sessionStorage.getItem("currencyDetails") || {};
        obj = JSON.parse(obj);
        if (callback) {
          callback(obj);
        }
        let currencies = obj["rates"] || { USD: 1.0 };
        let rates = Object.keys(currencies).sort();
        return dispatch(setCurrency(rates, currencies));
      } else {
        getCurrencyDetails();
      }
    }
  };

export const getUserIPDetails = () => {
  let userIp = sessionStorage.getItem("userIp");
  let buyerId = localStorage.getItem("userid");

  if (!userIp) {
    return (dispatch) => {
      return fetch(
        "https://ipapi.co/json/?key=JWzTw2TRf981G4oH1uZB5EwoM7iuNetMOB70dIhbnTAaO121To",
        {
          method: "GET",
        }
      )
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            apiError('getUserIPDetails',  res.statusText || "Error while fetching user IP details.", 'GET', 'currencyConverter');
            throw res;
          }
        })
        .then((result) => {
          sessionStorage.setItem("userIp", JSON.stringify(result));
          return dispatch(setUserIPDetails(result));
        })
        .catch((error) => {
          logger("error", "Error from getUserIPDetails api:" +error.statusText+': buyerId => '+buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
          apiError('getUserIPDetails', error.statusText, 'GET', 'currencyConverter');
          if(error.status === 401){
            Router.push('/signin');
          } else {
            if (retryCountIP < 3) {
              getUserIPDetails();
            }
            retryCountIP++;
          }
        });
    };
  } else {
    let userIpDetails = JSON.parse(userIp);
    return (dispatch) => {
      return dispatch(setUserIPDetails(userIpDetails));
    };
  }
};

export const saveUserIPDetails = (ipData, token, buyerId) => async (dispatch) => {
  let url = process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL + "/profile/v1/verify/social";
  fetch(url, {
    method: "POST",
    body: JSON.stringify(ipData),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
       'trace-id' : uuidv4()
    },
  })
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        apiError('CompleteUserRegistration', res.statusText ||
          "Error while saving user details. Please try again!", 'PATCH', 'userProfile');
        throw (
          res.statusText ||
          "Error while saving user details. Please try again!"
        );
      }
    })
    .then((res) => {
      // callback(res);
      console.log('response from saveUserIPDetails' ,res)
      // return dispatch(setUserProfile(res));
    })
    .catch((err) => {
      logger("error", "Error from saveUserIPDetails api:" +url + ",payload=" + JSON.stringify(ipData) +err+ ': for buyerId:' + buyerId, process.env.NEXT_PUBLIC_LOGGER_URL);
      apiError('CompleteUserRegistration', err, 'PATCH', 'userProfile');
      // callback({ error: err });
      console.log(err.message);
    });
}
